const SET_SLIDES = 'SET_SLIDES';
const GO_TO_SLIDE = 'GO_TO_SLIDE';
const NEXT_SLIDE = 'NEXT_SLIDE';
const SET_OFFER_COUNTER = 'SET_OFFER_COUNTER';
const SET_SLIDER_IMAGES = 'SET_SLIDER_IMAGES';


const setSlidesAction = slides => ({
  type: SET_SLIDES,
  payload: {
    slides
  }
});

const setSliderImages = images => ({
  type: SET_SLIDER_IMAGES,
  payload: images
});

const setOfferCounter = count => ({
  type: SET_OFFER_COUNTER,
  payload: {
    count
  }
});

const goToSlideAction = active => ({
  type: GO_TO_SLIDE,
  payload: {
    active
  }
});

const nextSlideAction = () => ({
  type: NEXT_SLIDE,
  payload: {}
});

export {
  SET_SLIDES,
  GO_TO_SLIDE,
  NEXT_SLIDE,
  SET_OFFER_COUNTER,
  SET_SLIDER_IMAGES,
  setSlidesAction,
  goToSlideAction,
  nextSlideAction,
  setOfferCounter,
  setSliderImages
};
